export default __webpack_public_path__ + "static/media/Ellipse 70.46429a0a.svg";